/**
 * As Seen On – No Design Store
 * Handles: modal open/close, tab switching, variant selection, add to cart
 */

(function () {
  'use strict';

  // ── Modal open/close ──────────────────────────────────────

  function openModal(modalId) {
    const modal = document.getElementById('aso-modal-' + modalId);
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    // Focus first focusable element
    const focusable = modal.querySelector(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled])'
    );
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }

  function closeModal(modalId) {
    const modal = document.getElementById('aso-modal-' + modalId);
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    // Return focus to trigger
    const trigger = document.querySelector('[data-aso-open="' + modalId + '"]');
    if (trigger) trigger.focus();
  }

  // Delegate: open
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-aso-open]');
    if (openBtn) {
      openModal(openBtn.dataset.asoOpen);
      return;
    }
    // Delegate: close (backdrop or close btn)
    const closeEl = e.target.closest('[data-aso-close]');
    if (closeEl) {
      closeModal(closeEl.dataset.asoClose);
    }
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('.aso-modal:not([hidden])');
    if (!open) return;
    const id = open.id.replace('aso-modal-', '');
    closeModal(id);
  });

  // Focus trap inside modal
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const modal = document.querySelector('.aso-modal:not([hidden])');
    if (!modal) return;
    const focusables = Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])'
      )
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });

  // ── Tab switching (multiple products per image) ───────────

  document.addEventListener('click', function (e) {
    const tab = e.target.closest('[data-aso-tab]');
    if (!tab) return;

    const panelId = tab.dataset.asoTab;
    const tabList = tab.closest('[role="tablist"]');
    const panelContainer = tabList.nextElementSibling; // .aso-panels

    // Update tabs
    tabList.querySelectorAll('[data-aso-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });

    // Update panels
    panelContainer.querySelectorAll('.aso-panel').forEach(function (p) {
      p.classList.toggle('is-active', p.id === 'aso-panel-' + panelId);
    });
  });

  // ── Variant selection & price/availability sync ───────────

  function getSelectedOptions(form) {
    const opts = [];
    form.querySelectorAll('[data-option-val]').forEach(function (el) {
      if (el.type === 'radio') {
        if (el.checked) opts[parseInt(el.dataset.optionVal)] = el.value;
      } else if (el.tagName === 'SELECT') {
        opts[parseInt(el.dataset.optionVal)] = el.value;
      }
    });
    return opts;
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (v) {
      return selectedOptions.every(function (opt, i) {
        return v['option' + (i + 1)] === opt;
      });
    }) || null;
  }

  function syncVariant(pcard) {
    const form     = pcard.querySelector('[data-product-form]');
    const jsonEl   = pcard.querySelector('[data-variants-json]');
    if (!form || !jsonEl) return;

    const variants = JSON.parse(jsonEl.textContent);
    const selected = getSelectedOptions(form);
    const variant  = findVariant(variants, selected);

    // Variant ID hidden input
    const idInput = form.querySelector('[data-variant-id-input]');
    if (idInput && variant) idInput.value = variant.id;

    // Price
    const priceEl   = pcard.querySelector('[data-price]');
    const compareEl = pcard.querySelector('.aso-pcard__price--compare');
    if (priceEl && variant) {
      priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
    }

    // ATC button
    const atcBtn  = pcard.querySelector('[data-atc-btn]');
    const atcText = pcard.querySelector('[data-atc-text]');
    if (atcBtn) {
      const available = variant ? variant.available : false;
      atcBtn.disabled = !available;
      if (atcText) atcText.textContent = available ? 'Sepete Ekle' : 'Tükendi';
    }

    // Update selected-label displays
    pcard.querySelectorAll('[data-selected-label]').forEach(function (label) {
      const idx = parseInt(label.dataset.selectedLabel);
      if (selected[idx] !== undefined) label.textContent = selected[idx];
    });

    // Active class on size/swatch labels
    pcard.querySelectorAll('.aso-pcard__sizes, .aso-pcard__swatches').forEach(function (group) {
      const idx = parseInt(group.dataset.optionGroup);
      group.querySelectorAll('label').forEach(function (lbl) {
        const inp = lbl.querySelector('input');
        if (inp) lbl.classList.toggle('is-active', inp.checked);
      });
    });
  }

  // Listen for any option change inside a pcard
  document.addEventListener('change', function (e) {
    const optionInput = e.target.closest('[data-option-val]');
    if (!optionInput) return;
    const pcard = optionInput.closest('.aso-pcard');
    if (pcard) syncVariant(pcard);
  });

  // ── Add to Cart ───────────────────────────────────────────

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const pcard   = form.closest('.aso-pcard');
    const atcBtn  = form.querySelector('[data-atc-btn]');
    const atcText = form.querySelector('[data-atc-text]');
    const spinner = form.querySelector('.aso-pcard__atc-spinner');
    const idInput = form.querySelector('[data-variant-id-input]');
    if (!idInput || !idInput.value) return;

    // Loading state
    if (atcText) atcText.hidden = true;
    if (spinner) spinner.hidden = false;
    if (atcBtn)  atcBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(idInput.value), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function () {
        // Restore button with feedback
        if (atcText) { atcText.textContent = 'Eklendi ✓'; atcText.hidden = false; }
        if (spinner) spinner.hidden = true;
        if (atcBtn)  atcBtn.disabled = false;

        // Trigger Broadcast / generic cart drawer open
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // Also try Broadcast's native event
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));

        // Also refresh native Shopify cart count if element exists
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function () {});

        // Reset text after delay
        setTimeout(function () {
          if (atcText) atcText.textContent = 'Sepete Ekle';
        }, 2500);
      })
      .catch(function (err) {
        console.error('[ASO] Add to cart error:', err);
        if (atcText) { atcText.textContent = 'Hata – tekrar dene'; atcText.hidden = false; }
        if (spinner) spinner.hidden = true;
        if (atcBtn)  atcBtn.disabled = false;
        setTimeout(function () {
          if (atcText) atcText.textContent = 'Sepete Ekle';
        }, 3000);
      });
  });

  // ── Helpers ───────────────────────────────────────────────

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    // Fallback: simple TRY format
    return (cents / 100).toLocaleString('tr-TR', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'TRY',
    });
  }

})();
